import { render, staticRenderFns } from "./OrderImport.vue?vue&type=template&id=90529146&scoped=true"
import script from "./OrderImport.vue?vue&type=script&lang=js"
export * from "./OrderImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90529146",
  null
  
)

export default component.exports